<template>
    <v-dialog v-model="dialog" persistent max-width="850px" @click:outside="cerrarDialogo()">
        <v-card class="rounded-lg elevation-3 overflow-hidden">
            <v-toolbar height="54" color="secondary" dark flat class="px-3 px-md-4">
                <v-icon left>mdi-clipboard-check-outline</v-icon>
                <span class="text-subtitle-1 font-weight-medium">Criterios de Aceptación</span>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="cerrarDialogo()" class="btn-circle-tooltip">
                    <v-icon size="20">mdi-close</v-icon>
                </v-btn>
            </v-toolbar>           
            <v-card-text class="pa-4 pa-md-5">
                <v-row dense>
                    <v-col cols="12" sm="12" md="5" class="pa-2">        
                        <div class="section-title d-flex align-center mb-3">
                            <v-icon color="secondary" small class="mr-2">mdi-format-list-checks</v-icon>
                            <span class="text-subtitle-2 font-weight-bold text--primary">
                                Índices de Criterio de Aceptación
                            </span>
                        </div>
                            
                        <div class="table-responsive-wrapper rounded-lg border-subtle overflow-hidden">
                            <table class="modern-mini-table" style="width: 100%">
                                <thead>
                                    <tr class="header-dark">
                                        <th class="table-border pa-2" style="width: 50%">
                                            MODELO
                                        </th>
                                        <th class="table-border pa-2" style="width: 50%">
                                            MEDIDA
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="table-border pa-2 text-caption">modelo prueba</td>
                                        <td class="table-border pa-2 text-caption">medida prueba</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </v-col>
                    <v-col cols="12" sm="12" md="7" class="pa-2">
                        <div class="section-title d-flex align-center mb-3">
                            <v-icon color="secondary" small class="mr-2">mdi-speedometer</v-icon>
                            <span class="text-subtitle-2 font-weight-bold text--primary">
                                Indicador Costo por KM / H
                            </span>
                        </div>
                        <div class="table-responsive-wrapper rounded-lg border-subtle overflow-hidden">
                            <table class="modern-mini-table" style="width: 100%">
                                <thead>
                                    <tr class="header-dark">
                                        <th class="table-border pa-2" style="width: 38%">
                                            MODELO
                                        </th>
                                        <th class="table-border pa-2" style="width: 38%">
                                            MEDIDA
                                        </th>
                                        <th class="table-border pa-2 text-center" style="width: 24%">
                                            ACCIÓN
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="table-border pa-2 text-caption">modelo prueba</td>
                                        <td class="table-border pa-2 text-caption">medida prueba</td>
                                        <td class="table-border pa-2 text-center">
                                            <v-btn small color="success" class="px-2 text-none font-weight-bold elevation-1" height="28">
                                                <v-icon left x-small>mdi-check</v-icon>
                                                Registrar
                                            </v-btn>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-4 bg-light d-flex justify-end gap-2">
                <v-btn outlined color="grey darken-2" class="px-4 text-none font-weight-medium rounded-lg" @click="cerrarDialogo()">
                    Cancelar
                </v-btn>
                <v-btn color="primary" class="px-5 text-none font-weight-bold elevation-1 rounded-lg" @click="guardarIncidencia()" :loading="loading">
                    <v-icon left small>mdi-content-save</v-icon>
                    Guardar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { notif } from '@/plugins/notyf';
export default {
    props: ['dialog'],
    data() {
        return {
            valid: false,
            loading: false,
            incidente: {},
            descripcionRules: [
                v => !!v || 'Descripción es requerido',
                v => (v && v.length <= 1000) || 'Descripción debe tener menos de 1000 caracteres',
            ],
            item: {
                aplicativo: "vue",
                descripcion: "",
                image_one: null,
                image_two: null
            },
            cabecera: [
                {
                    text: 'Placa',
                    value: 'placa_vehiculo',
                    width: 200,
                    class: "grey darken-1 dark white--text"
                },
                {
                    text: 'Serie',
                    value: 'serie_neumatico',
                    width: 200,
                    class: "grey darken-1 dark white--text"
                },
                {
                    text: 'Opcion',
                    value: 'accion',
                    width: 100,
                    class: "grey darken-1 dark white--text"
                },
            ],
            items: [],
            vehiculo: {},
            vehiculos: [],
            neumaticos: [],
            incidente: {
                placa: null,
                serie: null,
                id_neumatico: null,
                id_vehiculo: null
            },
            nombreusuario: ""
        };
    },
    computed: {
        ...mapState("cliente", ["Cliente"]),
    },
    methods: {
        ...mapActions("vehiculo", ["cargarVehiculosMinified", "cargarNeumaticosPorId"]),
        ...mapActions("neumatico", ["cargarNeumaticosMinified"]),
        ...mapActions("incidente", ["subirImagenes", "guardarIncidente"]),
        ...mapActions("cliente", ["ObtenerDatosCliente"]),

        async onCargarNeumaticos() {
            try {
                this.neumaticos = await this.cargarNeumaticosPorId(this.incidente.id_vehiculo);
                this.vehiculos.forEach(element => {
                    if (element.value == this.incidente.id_vehiculo) {
                        this.incidente.placa_vehiculo = element.text;
                    }
                });
            } catch (error) {
                console.log(error);
            }
        },

        onSerieNeumatico() {
            this.neumaticos.forEach(element => {
                if (element.value == this.incidente.id_neumatico) {
                    this.incidente.serie_neumatico = element.text;
                }
            });
        },

        async guardarIncidencia() {
            let status = false;
            if (this.$refs.form.validate()) {
                try {
                    let datosaenviar = { incidente: this.item, detalles: this.items };
                    status = await this.guardarIncidente(datosaenviar);
                    if (status == true) {
                        notif.success("Incidencia enviada con éxito");
                        this.cerrarDialogo();
                    }
                } catch (error) {
                    console.log(error);
                }
            }
        },

        agregarIncidencia() {
            let existe = false;
            this.items.forEach(element => {
                if (element.id_vehiculo == this.incidente.id_vehiculo && element.id_neumatico == this.incidente.id_neumatico) {
                    existe = true;
                }
            });
            //Si el neumatico no esta en el array incidentes registrar
            if (!existe) {
                if (this.incidente.id_vehiculo != null && this.incidente.id_neumatico != null) {
                    this.items.push({ ...this.incidente });
                } else {
                    if (this.incidente.id_vehiculo == null) {
                        notif.open({ type: 'warning', message: 'La placa del vehículo es requerida' });
                    } else {
                        notif.open({ type: 'warning', message: 'La serie de neumático es requerida' });
                    }
                }
            } else {
                notif.open({ type: 'warning', message: 'El neumático seleccionado ya a sido agregado' });
            }
            this.incidente.serie_neumatico = null;
            this.incidente.id_neumatico = null;
        },

        eliminarItem(item) {
            const pos = this.items.indexOf(item);
            this.items.splice(pos, 1);
        },

        async subirImagen1() {
            try {
                let file = document.getElementById('img_firma1').files[0];
                this.item.image_one = await this.subirImagenes(file);
            } catch (error) {
                console.log(error);
            }
        },

        async subirImagen2() {
            try {
                let file = document.getElementById('img_firma1').files[0];
                this.item.image_two = await this.subirImagenes(file);
            } catch (error) {
                console.log(error);
            }
        },

        cerrarDialogo() {
            this.$emit("cerrarModalModeloMedidas");
        }
    },
    async mounted() {
        this.vehiculos = await this.cargarVehiculosMinified();
        this.nombreusuario = localStorage.getItem("name");
    }
};
</script>

<style scoped>
.section-title {
    border-left: 3px solid #424242;
    padding-left: 8px;
    margin-bottom: 12px;
}

.bg-light {
    background-color: #f8fafc;
}

.gap-2 {
    gap: 8px;
}

.border-subtle {
    border: 1px solid #e2e8f0;
}

.table-border {
    border: 1px solid #e2e8f0;
}

.modern-mini-table {
    border-collapse: collapse;
    width: 100%;
}

.header-dark th {
    background-color: #424242 !important;
    color: #ffffff !important;
    font-size: 0.78rem !important;
    font-weight: 700 !important;
    text-transform: uppercase !important;
    letter-spacing: 0.5px !important;
    border: 1px solid #525252 !important;
}

.modern-mini-table tbody tr:hover {
    background-color: #f8fafc;
}

.table-responsive-wrapper {
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}

.btn-circle-tooltip {
    background: rgba(255, 255, 255, 0.16) !important;
    border: 1px solid rgba(255, 255, 255, 0.25) !important;
    border-radius: 50% !important;
    width: 36px !important;
    height: 36px !important;
    min-width: 36px !important;
    max-width: 36px !important;
    padding: 0 !important;
    margin: 0 !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    text-decoration: none !important;
    transition: all 0.2s ease-in-out !important;
}

.btn-circle-tooltip:hover {
    background: rgba(255, 255, 255, 0.28) !important;
    border-color: rgba(255, 255, 255, 0.45) !important;
}
</style>